import {
  FETCH_USER_DATA,
  FETCH_USER_DATA_SUCCESS,
  FETCH_USER_DATA_FAILED,
} from "../actions/actions_fetchUsers";

const initialState = {
  data: {},
  isLoading: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_USER_DATA:
      return {
        ...state,
        data: {},
        error: false,
      };
    case FETCH_USER_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: false,
      };
    case FETCH_USER_DATA_FAILED:
      return {
        ...state,
        data: {},
        isLoading: false,
        error: true,
      };
    default:
      return state;
  }
}
